module.exports = __webpack_public_path__ + "static/media/data-view-icon.8c53684c.svg";